const init = () => {
  for (let i = 1; i <= 10; i++) {
    $(`.sc-icon-system${i}`).addClass(`s3-icon-system${i}`);
  }


  function setLeft(card, left) {
    const firstItem = card.find('.system-item').first();
    firstItem.animate({marginLeft: `${left}px`}, 500);
    card.data('left', left);
    const maxLeft = card.data('maxLeft');
    if (left >= 0) {
      card.find('.view-left-arrow').hide();
    } else {
      card.find('.view-left-arrow').show();
    }
    if (left * (-1) >= maxLeft) {
      card.find('.view-right-arrow').hide();
    } else {
      card.find('.view-right-arrow').show();
    }
  }

  $('.systemLogin-card').on('click', '.view-right-arrow', function () {
    const card = $(this).parents('.systemLogin-card');
    const nowLeft = card.data('left') || 0;
    const newLeft = nowLeft - 600;
    setLeft(card, newLeft);
  }).on('click', '.view-left-arrow', function () {
    const card = $(this).parents('.systemLogin-card');
    const nowLeft = card.data('left') || 0;
    const newLeft = nowLeft + 600;
    setLeft(card, newLeft);
  }).each(function () {
    const lastItem = $(this).find('.system-item').last();
    let mexLeft = lastItem.offset().left - $(this).offset().left - 1200 + 270;
    $(this).data('maxLeft', mexLeft);
  }).each(function () {
    setLeft($(this), 0);
  });
};
module.exports = {init};